import * as React from 'react';
import {
  FormControlLabel as MuiFormControlLabel,
  FormHelperText as MuiFormHelperText,
} from '@material-ui/core';
import { SelectionControlsCoreLabelProps } from 'omakase/SelectionControls/RadioButton';
import { Theme } from '@emotion/react';
import {
  formControlLabel,
  formControlLabelHelperText,
  formControlLabelPrimary,
} from 'omakase/SelectionControls/selectionControlsCssDefs';
import SelectionControlsCore, {
  SelectionControlsCoreProps,
} from 'omakase/SelectionControls/SelectionControlsCore';

interface CheckboxLabelProps {
  /**
   * Whether or not the checkbox should display an error state (standalone field checkboxes only - N/A within a checkbox group)
   */
  error?: boolean;
  /**
   * Error text to display if the checkbox is in an error state (standalone field checkboxes only - N/A within a checkbox group)
   */
  errorText?: string;
  /**
   * Whether or not the checkbox is part of a group - set to true when component passed as child to CheckboxGroup or FormCheckboxGroup
   */
  group?: boolean;
}

export type CheckboxProps = SelectionControlsCoreProps &
  SelectionControlsCoreLabelProps &
  CheckboxLabelProps;

/**
 * Checkbox with label.
 * If using within a Formik form, use FormCheckbox.
 */
const Checkbox: React.FunctionComponent<CheckboxProps> = ({
  size = 'small',
  weight = 'medium',
  error = false,
  errorText,
  helperText,
  label,
  value,
  group = false,
  className,
  ...rest
}) => {
  return (
    <MuiFormControlLabel
      css={formControlLabel}
      className={className}
      control={<SelectionControlsCore {...rest} type="checkbox" value={value} />}
      value={value}
      label={
        <>
          <span css={(theme: Theme) => formControlLabelPrimary(theme, weight, size)}>{label}</span>
          {(helperText || errorText) && (
            <MuiFormHelperText
              css={(theme: Theme) => formControlLabelHelperText(theme, { error: !group && error })}
            >
              {!group && error ? errorText : helperText}
            </MuiFormHelperText>
          )}
        </>
      }
    />
  );
};
export default Checkbox;
